import clsx from "clsx";
import { View } from ".";

type SettingsListProps = {
  children: React.ReactNode;
  className?: string;
};

export const SettingsList = ({ children, className }: SettingsListProps) => {
  return (
    <View
      className={clsx(
        "bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden",
        "divide-y divide-gray-200 dark:divide-gray-700",
        className,
      )}
    >
      {children}
    </View>
  );
};
